import { render } from "./projectStatus.vue?vue&type=template&id=6f71d022&scoped=true&ts=true"
import script from "./projectStatus.vue?vue&type=script&lang=ts"
export * from "./projectStatus.vue?vue&type=script&lang=ts"

import "./projectStatus.vue?vue&type=style&index=0&id=6f71d022&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f71d022"]])

export default __exports__